
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/r/[region]",
      function () {
        return require("private-next-pages/r/[region].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/r/[region]"])
      });
    }
  